import { BSC_POOLS } from './bscPools';
import { BSC_POOLS as BSC_TEST_POOLS } from './bscTestPools';
import { ETH_POOLS } from './ethTestPools';
// import { ETH_POOLS } from './ethPools';
//import { POLY_POOLS } from './polyPools';
import { StakingPool } from './staking.types';

export const StakingData: StakingPool[] = [...ETH_POOLS, ...BSC_POOLS, ...BSC_TEST_POOLS];
